/**
 * Draws a rectangle of walls at exact measured dimensions, centred in the view.
 * Starting from a rectangle and then pulling corners around is far easier than
 * drawing an odd shape freehand, and it means the plan begins at true size
 * instead of at whatever the grid snapped to.
 */
import { main } from "../EditorRoot";
import { WALL_THICKNESS } from "./constants";
import { FloorPlan } from "./objects/FloorPlan";
import { metersToPixels } from "./units";

export function createRoomRectangle(widthMeters: number, lengthMeters: number) {
    if (!(widthMeters > 0) || !(lengthMeters > 0)) {
        return false;
    }
    const floorPlan = FloorPlan.Instance;
    const sequence = floorPlan.getWallNodeSeq();

    // Node centres sit one wall thickness apart from the clear span, so the
    // labels read back the numbers that were typed in.
    const width = metersToPixels(widthMeters) + WALL_THICKNESS;
    const length = metersToPixels(lengthMeters) + WALL_THICKNESS;

    const centreX = (main?.worldWidth ?? 2000) / 2;
    const centreY = (main?.worldHeight ?? 2000) / 2;
    const left = Math.round(centreX - width / 2);
    const top = Math.round(centreY - length / 2);

    const corners = [
        sequence.addNode(left, top),
        sequence.addNode(left + width, top),
        sequence.addNode(left + width, top + length),
        sequence.addNode(left, top + length),
    ];

    for (let i = 0; i < corners.length; i++) {
        const wall = sequence.addWall(
            corners[i].getId(),
            corners[(i + 1) % corners.length].getId()
        );
        if (wall) {
            wall.setIsExterior(true);
        }
    }

    floorPlan.redrawWalls();
    return true;
}
